import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import deviceDetector from './utils/deviceDetector'
import { useAuthStore } from './store/auth'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.use(deviceDetector)
app.mount('#app')

const refreshIdentity = () => {
  const auth = useAuthStore(pinia)
  auth.refreshIdentityOnReturn().catch(() => {})
}
window.addEventListener('focus', refreshIdentity)
window.addEventListener('pageshow', refreshIdentity)
